module.exports = __webpack_public_path__ + "static/img/3areaA_3.dd42295.png";


//////////////////
// WEBPACK FOOTER
// ./static/mycard/character1/タイラニャン/3areaA_3.png
// module id = 843
// module chunks = 1